module.exports = __webpack_public_path__ + "img/prusa_layers.53a27296.gif";